import type { MutationConfig } from "apps/visits/core/lib/react-query";
import type { AxiosError } from "axios";
import { useMutation } from "react-query";
import { VouchersDistributionsRepository } from "../vouchers-distribution.api";
import type { ValidateUserErrorResponse } from "./validate-user.types";

const vouchersDistributionsRepository = new VouchersDistributionsRepository();
type UseValidateUserOptions = {
  config?: MutationConfig<typeof vouchersDistributionsRepository.validateUser, AxiosError<ValidateUserErrorResponse>>;
};

export const useValidateUser = ({ config }: UseValidateUserOptions) => {
  return useMutation({
    ...config,
    mutationFn: (data) => vouchersDistributionsRepository.validateUser(data),
  });
};
